export const conf = {
    apiURL: "https://api-dashboard.amarilio.net/",
    //apiURL: "http://localhost:8000/",
}